import WaterfallChart from "./WaterfallChart"
import EconomicIndicatorsPanel from "./EconomicIndicatorsPanel"
export default function TotalCapitalRequirement(props) {

    // -----------------------------
    // TOTAL CAPITAL REQUIREMENTS
    // -----------------------------
    const totalProcessCapital = props.totalProcessCapital || 0;

    const cc = props.settings.constructionCapital;
    const dl = props.settings.directLabor || {};
    const oc = props.settings.otherCosts
    const processSteps = props.processSteps

    const userPrice = props.price;
    const userCapacity = props.capacity;

    const totalOPEX = processSteps.map(obj => obj.opex).reduce((a, b) => a + b, 0)

    ////// Calculating Total Mass & Total Revenue //////
    //**************************/
    const temp = () => {
                        let totalMass = 0;
                        let totalRevenue = 0;
                        processSteps.flatMap((p, i) => {
                            if (!p.finalProducts || !p.yields) return [];

                        return Object.entries(p.finalProducts)
                            .filter(([, v]) => v.isFinal)
                            .map(([product, v]) => {
                                const y = p.yields[product] || 0;
                                const mass = (p.currentCapacity) * y;
                                const price = v.price || 0;
                                const revenue = mass * price;

                                totalMass += mass;
                                totalRevenue += revenue;
                        });
                      });

                      return [totalMass, totalRevenue];};
       
    const totallll = temp()
    const totalMass = totallll[0]
    const totalRevenues = totallll[1]

    ////// TOTAL TCI Sheet //////
    //**************************/
    // General Facilities
    const generalFacilities = totalProcessCapital * cc.generalFacilitiesPct;

    // Home office, Overhead and Fee
    const homeOfficeOverheadFee = totalProcessCapital * cc.homeOfficePct;

    // Project Contingencies
    const projectContingencies = totalProcessCapital * cc.projectContingenciesPct;

    // TOTAL PLANT COSTS: Total Process Capital + the three add-ons
    const totalPlantCosts = totalProcessCapital + generalFacilities + homeOfficeOverheadFee + projectContingencies;
    // --------------------------------//

    // Pre-paid royalties (of Total Process Capital)
    const prepaidRoyalties = totalProcessCapital * cc.prepaidRoyaltiesPct;

    // Start-up Costs (of Total Plant Costs)
    const startupCosts = totalPlantCosts * cc.startupCostsPct;

    // Total Start-up (same as Start-up Costs)
    const totalStartup = startupCosts;
    
    // Working Capital (of Total Process Capital)
    const workingCapital = totalProcessCapital * cc.workingCapitalPct;

    // TOTAL CAPITAL REQUIREMENTS
    const totalCapitalRequirements =
      totalPlantCosts + prepaidRoyalties + totalStartup + workingCapital;

    // OF WHICH DEPRECIABLE INVESTMENT
    const depreciableInvestment = totalCapitalRequirements - workingCapital;
    ////// End of TOTAL TCI Sheet //////
    /////*************************/////

    ////// Start of Operating Costs //////
    //////**************************//////

    const directOperatingLabour = dl.labourCostPerOperator * dl.operatorsPerShift * (dl.shiftsPerDay + dl.additionalShifts);

    // Direct Supervision
    const directSupervision = directOperatingLabour * dl.directSupervisionPct

    // Maintenance Labour
    const maintenanceLabour = totalPlantCosts * dl.maintenanceLabourPct

    //  Total direct labour
    const totalDirectLabour = directOperatingLabour + directSupervision + maintenanceLabour

    // Indirect Labour
    const indirectLabour = totalDirectLabour * props.settings.indirectLabor.indirectLabourPct
     
    // Total Annual Labour
    // const totalAnnualLabour = totalDirectLabour + indirectLabour

    // Maintenance Material Costs
    const maintenanceMaterialCosts = totalPlantCosts * oc.maintenanceMaterialPct

    // Indirect Material Costs
    const indirectMaterialCosts = totalDirectLabour * oc.indirectMaterialPct

    // Property Taxes and Insurance
    const propertyTaxesAndInsurance = totalPlantCosts * oc.propertyTaxesPct

    // Sales Expense 
    const salesExpense = totalRevenues * oc.salesExpensePct

    const totalOtherCosts = maintenanceMaterialCosts + indirectMaterialCosts + propertyTaxesAndInsurance + salesExpense

    // TOTAL ANNUAL OPERATING COSTS
    // const totalAnnualOperatingCosts = totalAnnualLabour + totalOtherCosts

    // capitalRecoveryFactorPct
    const crf = totalCapitalRequirements*cc.capitalRecoveryFactorPct / (1- Math.pow(1+cc.capitalRecoveryFactorPct, -1*props.settings.operatingYears))

    function calculateIRR (cashFlows, guess = 0.1) {
            let rate = guess;
            const maxIterations = 1000;
            const precision = 1e-7;

            for (let i = 0; i < maxIterations; i++) {
                let npv = 0;
                let dNpv = 0;

                cashFlows.forEach((cf, t) => {
                npv += cf / Math.pow(1 + rate, t);
                dNpv -= (t * cf) / Math.pow(1 + rate, t + 1);
                });

                const newRate = rate - npv / dNpv;
                if (Math.abs(newRate - rate) < precision) {
                return newRate;
                }
                rate = newRate;
            }

            return rate;
            }

    function calculateIRRAndCashflow() {
                const years = props.settings.operatingYears;
                const investment = -1*totalCapitalRequirements/1000000;
                const revenues = totalRevenues/1000000;
                const variableCosts = -1*(userCapacity*userPrice + totalOPEX)/1000000
                const fixedCosts = -1.189129;

                // yearly operating cash flow
                const annualCashFlow =
                    revenues + variableCosts + fixedCosts;

                // build cash flow array
                const cashFlows = [
                    investment+annualCashFlow,
                    ...Array(years).fill(annualCashFlow)
                ];

                const irr = calculateIRR(cashFlows);                
                return [
                    annualCashFlow,
                    irr
                ];
            }
    
    const IRR_CF = calculateIRRAndCashflow()
    
    ////////////////////////////////////////////////////
    const lcopItems = [
     { name: "Algae", value: userCapacity*userPrice/totalMass },
     { name: "Utilities", value: totalOPEX/totalMass },
     { name: "Total Direct Labour", value: totalDirectLabour/totalMass  },
     { name: "Indirect Labour", value: indirectLabour/totalMass},
     { name: "Total Other costs", value: totalOtherCosts/totalMass },
     { name: "Capital costs", value: crf/totalMass },
   ];

    const total = lcopItems.map(obj => obj.value).reduce((a, b) => a + b, 0);

  return (
        <div>
            <h4 className="text-lg font-semibold mb-3 hidden">Total Capital Requirements</h4>
            <div className="overflow-x-auto hidden">
                <table className="min-w-full border text-sm">
                <thead className="bg-gray-100">
                    <tr>
                    <th className="border px-2 py-1 text-left">Item</th>
                    <th className="border px-2 py-1 text-right">Assumption</th>
                    <th className="border px-2 py-1 text-right">Value</th>
                    <th className="border px-2 py-1 text-left">Unit</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                    <td className="border px-2 py-1 font-medium">Total process capital</td>
                    <td className="border px-2 py-1 text-right">—</td>
                    <td className="border px-2 py-1 text-right">
                        {Math.round(totalProcessCapital).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr>
                    <td className="border px-2 py-1">General Facilities</td>
                    <td className="border px-2 py-1 text-right">
                        {(cc.generalFacilitiesPct * 100).toFixed(2)}% of Total process capital
                    </td>
                    <td className="border px-2 py-1 text-right">
                        {Math.round(generalFacilities).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr>
                    <td className="border px-2 py-1">Home office, Overhead and Fee</td>
                    <td className="border px-2 py-1 text-right">
                        {(cc.homeOfficePct * 100).toFixed(2)}% of Total process capital
                    </td>
                    <td className="border px-2 py-1 text-right">
                        {Math.round(homeOfficeOverheadFee).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr>
                    <td className="border px-2 py-1">Project Contingencies</td>
                    <td className="border px-2 py-1 text-right">
                        {(cc.projectContingenciesPct * 100).toFixed(2)}% of Total process capital
                    </td>
                    <td className="border px-2 py-1 text-right">
                        {Math.round(projectContingencies).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr className="bg-gray-100 font-semibold">
                    <td className="border px-2 py-1 text-red-700">TOTAL PLANT COSTS</td>
                    <td className="border px-2 py-1 text-right">—</td>
                    <td className="border px-2 py-1 text-right text-red-700">
                        {Math.round(totalPlantCosts).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr>
                    <td className="border px-2 py-1">Pre-paid royalties</td>
                    <td className="border px-2 py-1 text-right">
                        {(cc.prepaidRoyaltiesPct * 100).toFixed(2)}% of Total process capital
                    </td>
                    <td className="border px-2 py-1 text-right">
                        {prepaidRoyalties.toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr>
                    <td className="border px-2 py-1">Start-up Costs</td>
                    <td className="border px-2 py-1 text-right">
                        {(cc.startupCostsPct * 100).toFixed(2)}% of Total plant costs
                    </td>
                    <td className="border px-2 py-1 text-right">
                        {Math.round(startupCosts).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr className="bg-gray-50 font-semibold">
                    <td className="border px-2 py-1">Total Start-up</td>
                    <td className="border px-2 py-1 text-right"></td>
                    <td className="border px-2 py-1 text-right">
                        {Math.round(totalStartup).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr>
                    <td className="border px-2 py-1">Working Capital</td>
                    <td className="border px-2 py-1 text-right">
                        {(cc.workingCapitalPct * 100).toFixed(2)}% of Total process capital
                    </td>
                    <td className="border px-2 py-1 text-right">
                        {Math.round(workingCapital).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr className="bg-gray-100 font-semibold">
                    <td className="border px-2 py-1 text-red-700">
                        TOTAL CAPITAL REQUIREMENTS
                    </td>
                    <td className="border px-2 py-1 text-right">
                        
                    </td>
                    <td className="border px-2 py-1 text-right text-red-700">
                        {Math.round(totalCapitalRequirements).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>

                    <tr className="bg-gray-50 font-semibold">
                    <td className="border px-2 py-1 text-red-700">
                        OF WHICH DEPRECIABLE INVESTMENT
                    </td>
                    <td className="border px-2 py-1 text-right">
                        
                    </td>
                    <td className="border px-2 py-1 text-right text-red-700">
                        {Math.round(depreciableInvestment).toLocaleString()}
                    </td>
                    <td className="border px-2 py-1">EUR</td>
                    </tr>
                </tbody>
                </table>
            </div>


            <table className="my-5"
                style={{
                borderCollapse: "collapse",
                width: "100%",
                fontSize: "11pt", display: "None"
                }}
            >
                <thead>
                <tr>
                    <th className="border px-2 py-1"></th>
                    <th className="border px-2 py-1">value</th>
                    <th className="border px-2 py-1">unit</th>
                </tr>
                </thead>

                <tbody>
                <tr>
                    <td className="border px-2 py-1">Total Capital Requirements</td>
                    <td className="border px-2 py-1 text-right">{(totalCapitalRequirements/1000000).toFixed(3)}</td>
                    <td className="border px-2 py-1">MEuro</td>
                </tr>

                <tr>
                    <td className="border px-2 py-1">Pay Out Time, before tax</td>
                    <td className="border px-2 py-1 text-right">{(totalCapitalRequirements/(IRR_CF[0]*1000000)).toFixed(2)}</td>
                    <td className="border px-2 py-1">[year after start production]</td>
                </tr>

                <tr>
                    <td className="border px-2 py-1">Return on Investment (ROI)</td>
                    <td className="border px-2 py-1 text-right">{(100*IRR_CF[0]*1000000/totalCapitalRequirements).toFixed(2)}%</td>
                    <td className="border px-2 py-1">[per year]</td>
                </tr>

                <tr>
                    <td className="border px-2 py-1">IRR</td>
                    <td className="border px-2 py-1 text-right">{(IRR_CF[1]*100).toFixed(2)}%</td>
                    <td className="border px-2 py-1">[per year]</td>
                </tr>

                <tr>
                    <td className="border px-2 py-1">
                    Levelised costs of product or Minimum selling price
                    </td>
                    <td className="border px-2 py-1 text-right">{Math.round(total).toLocaleString('gb-GB')}</td>
                    <td className="border px-2 py-1">Specific Costs [EUR/tonne]</td>
                </tr>

                

                <tr>
                    <td className="border px-2 py-1">Revenues</td>
                    <td className="border px-2 py-1 text-right">{(totalRevenues/1000000).toFixed(3)}</td>
                    <td className="border px-2 py-1">MEUR/y</td>
                </tr>
                </tbody>
            </table>

            <EconomicIndicatorsPanel
                totalCapitalRequirements={{ value: (totalCapitalRequirements/1000000).toFixed(3), unit: "MEuro" }}
                payOutTime={{ value: (totalCapitalRequirements/(IRR_CF[0]*1000000)).toFixed(2), unit: "year after start production" }}
                roi={{ value: (100*IRR_CF[0]*1000000/totalCapitalRequirements).toFixed(2), unit: "% per year" }}
                irr={{ value: (IRR_CF[1]*100).toFixed(2), unit: "% per year" }}
                minimumSellingPrice={{ value: Math.round(total).toLocaleString('gb-GB'), unit: "EUR/tonne" }}
                revenues={{ value: (totalRevenues/1000000).toFixed(3), unit: "MEUR/y" }}
            />
            

            <div style={{ display: "grid", gap: 24 }}>
                <WaterfallChart items={lcopItems} totalValue={total} />                
            </div>

            

        </div>
  )
}